import type { ClubMembershipView } from '@stm/contracts';
import { isCalendarDate } from '@stm/contracts';

export function membershipsPath(base: string, athleteId: string, membershipId?: string): string {
  const root = `${base}/athletes/${encodeURIComponent(athleteId)}/memberships`;
  return membershipId === undefined ? root : `${root}/${encodeURIComponent(membershipId)}/end`;
}

/** An empty start date lets the server use the club's current day. */
export function joinRequestBody(joinedOn: string): { joinedOn?: string } {
  return joinedOn === '' ? {} : { joinedOn };
}

export function canSubmitJoin(joinedOn: string): boolean {
  return joinedOn === '' || isCalendarDate(joinedOn);
}

/** Whether a period without an end date exists, so another one cannot be started. */
export function hasOpenMembership(memberships: readonly ClubMembershipView[]): boolean {
  return memberships.some((membership) => membership.leftOn === null);
}
